
export default {
	selected: state => state.selected,
	columns: state => state.columns,
	originalColumns: state => state.originalColumns,
	meta: state => state.meta,
	sortBy: state => state.sortBy,
	sortOrder: state => state.sortOrder,
	filters: state => state.filters,
	sorted: state => {
		// USED ONLY FOR LOCAL DATA SORTING
		let data = [...state.data]
		if (state.filters.length) {
			data = applyFilters(data, state.filters)
		}
		if (state.sortBy !== null) {
			data.sort((a, b) => {
				const c = { ...a }
				const d = { ...b }
				if (typeof c[state.sortBy] === 'string') {
					c[state.sortBy] = c[state.sortBy].toLowerCase()
					d[state.sortBy] = d[state.sortBy].toLowerCase()
				}

				if (c[state.sortBy] > d[state.sortBy]) {
					return 1
				}
				if (c[state.sortBy] < d[state.sortBy]) {
					return -1
				}
				return 0
			})
		}
		return data.map(item => {
			return {
				...item,
				columns: state.columns
			}
		})
	},
	data: state => {
		return state.data.map(item => {
			return {
				...item,
				columns: state.columns
			}
		})
	}
}

function applyFilters (data, filters) {
	let filtered = [...data]
	filters.forEach(filter => {
		switch (filter.mode) {
		case 'equal':
			filtered = filtered.filter(item => item[filter.key] === filter.value)
			break
		case 'greater':
			filtered = filtered.filter(item => item[filter.key] > filter.value)
			break
		case 'less':
			filtered = filtered.filter(item => item[filter.key] < filter.value)
			break
		case 'custom':
			filtered = filtered.filter(item => filter.filter(item))
			break
		}
	})
	return filtered
}
